import { IKogIcon } from "@/main/@types/interfaceIcons";

export function MesaDeComprasIcon({ height = "50px", width = "50px", color = "currentColor" }: IKogIcon) {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 493.000000 512.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
				<path
					d="M2345 5024 c-387 -54 -608 -164 -776 -387 -169 -224 -255 -520 -278
          -960 l-9 -168 -47 -50 c-25 -27 -58 -75 -73 -107 l-27 -57 0 -255 0 -255 27
          -58 c38 -80 117 -160 197 -200 62 -30 72 -32 176 -32 l111 0 28 -67 c99 -241
          300 -460 521 -567 143 -69 214 -86 365 -86 154 0 234 19 368 86 53 27 103 49
          110 49 8 0 12 -15 12 -44 0 -55 30 -96 70 -96 19 0 36 9 49 26 18 23 21 41 21
          136 l0 110 63 74 c75 90 156 221 194 315 l28 70 35 -5 c19 -3 50 -6 68 -6 l33
          0 -3 -417 c-3 -397 -4 -420 -23 -451 -27 -44 -66 -67 -148 -86 -98 -23 -112
          -21 -127 14 -17 42 -81 97 -130 111 -62 19 -425 -6 -500 -34 -75 -28 -151
          -104 -175 -176 -21 -65 -16 -159 14 -226 28 -63 100 -129 169 -155 85 -32 144
          -24 369 49 164 54 197 68 229 98 39 39 64 88 64 127 0 20 7 27 28 32 226 54
          280 87 344 207 23 42 23 47 26 489 l3 447 42 24 c60 36 134 118 165 185 l27
          57 0 255 0 255 -27 57 c-15 32 -48 80 -73 107 l-47 50 -9 168 c-14 267 -43
          437 -104 621 -135 403 -397 629 -823 708 -83 16 -482 28 -557 18z m526 -160
          c535 -86 766 -418 815 -1171 l6 -103 -81 0 c-122 0 -184 -32 -222 -115 -17
          -37 -19 -72 -19 -437 l0 -397 -26 -83 c-51 -161 -143 -307 -267 -424 -128
          -120 -247 -183 -396 -210 -96 -17 -146 -17 -242 0 -149 27 -268 90 -394 208
          -120 113 -206 246 -266 408 -23 64 -24 73 -29 490 -4 370 -7 429 -22 455 -41
          75 -103 105 -219 105 l-81 0 6 103 c23 354 85 604 198 795 18 31 71 95 118
          142 68 68 104 95 177 133 126 65 290 106 488 121 93 7 361 -4 456 -20z m-1277
          -1430 c14 -13 16 -63 16 -394 0 -445 7 -416 -104 -407 -86 8 -147 42 -193 110
          -41 60 -46 104 -41 344 l3 190 30 48 c34 55 95 103 146 115 59 14 126 11 143
          -6z m2135 -21 c62 -38 108 -108 116 -177 4 -29 5 -138 3 -242 -3 -186 -3 -190
          -31 -236 -47 -81 -133 -128 -233 -128 -77 0 -74 -16 -74 410 0 445 -7 416 104
          407 52 -5 81 -13 115 -34z m-566 -1895 c10 -8 23 -45 33 -91 13 -67 14 -81 2
          -99 -10 -15 -66 -37 -203 -80 -216 -68 -250 -69 -310 -17 -73 64 -67 202 11
          250 29 18 62 23 217 34 100 7 194 13 208 14 14 0 33 -5 42 -11z"
				/>
				<path
					d="M2345 4694 c-333 -60 -581 -236 -719 -510 -51 -102 -86 -232 -93
          -344 -5 -87 -4 -97 17 -122 28 -36 71 -38 98 -3 13 16 21 48 26 102 12 128 33
          211 80 307 78 159 171 255 326 336 274 142 686 142 960 -1 243 -126 379 -341
          405 -642 5 -54 13 -85 27 -102 27 -35 70 -33 98 3 21 25 22 34 17 122 -17 262
          -149 507 -362 667 -72 55 -215 126 -305 153 -169 50 -407 64 -575 34z"
				/>
				<path
					d="M2035 3970 c-9 -10 -25 -59 -35 -109 -22 -108 -63 -198 -124 -269
          -45 -52 -53 -73 -40 -107 10 -26 59 -46 86 -36 47 19 149 167 184 269 22 61
          32 64 104 27 99 -50 140 -55 472 -55 184 0 328 -4 360 -11 29 -6 86 -29 127
          -51 81 -44 104 -43 136 6 24 36 3 73 -65 114 -127 76 -126 76 -525 82 -205 4
          -373 11 -390 17 -55 19 -111 51 -168 97 -61 50 -94 57 -122 26z"
				/>
				<path
					d="M1956 1811 c-10 -11 -23 -48 -31 -84 -17 -80 -31 -108 -85 -169 -119
          -135 -390 -261 -794 -369 -254 -67 -376 -129 -501 -254 -150 -149 -202 -300
          -212 -610 -5 -175 -5 -181 17 -208 27 -34 68 -36 98 -4 19 20 22 35 22 103 0
          119 18 311 35 379 43 169 139 283 307 363 57 28 148 62 203 77 55 14 149 40
          208 57 59 17 109 29 110 27 2 -2 29 -37 62 -77 213 -265 538 -459 885 -527
          131 -26 352 -31 488 -11 413 61 781 283 1019 615 1 2 60 -12 130 -32 71 -20
          164 -45 208 -57 44 -11 126 -43 183 -71 168 -82 264 -196 307 -364 17 -67 35
          -260 35 -376 0 -62 4 -81 21 -103 28 -35 70 -35 98 0 19 24 21 40 21 158 -1
          221 -26 356 -92 495 -32 67 -56 100 -121 165 -129 127 -245 186 -517 260 -143
          39 -319 95 -426 137 -27 11 -36 10 -59 -5 -58 -38 -46 -101 25 -130 22 -9 40
          -22 40 -30 0 -19 -99 -132 -165 -190 -193 -166 -400 -268 -650 -318 -141 -29
          -389 -29 -530 0 -304 61 -573 213 -759 429 -59 68 -67 90 -38 100 9 3 59 26
          111 49 264 122 443 310 458 480 4 50 2 63 -17 87 -26 32 -69 36 -94 8z"
				/>
			</g>
		</svg>
	);
}
